import { IServiceResponse } from '../Interfaces/iservice-response';
import { UTCTimestamp } from 'lightweight-charts';

export interface IInitResponse
{
  activeConfigs:Config[];
  activeRetracements:ActiveRetracementsNames;
  lastSelectedRetracement:string;
  lastSelectedPriceRange:ActiveRanges;
  priceLines:string;
  magnituderAlerts:boolean;
  spotData?:CurrentSpotData;
}

export class ActiveRanges
{
  priceRange:string;
  timeRange:string;
}

export class ActiveRetracementsNames
{
  downWave:string;
  upWave:string;
}
export interface ISendWave
{
  testWaveResponse:string;
}

export class ISendTradeDataResponse
{
  tradeData:ISendTradeData;
 // cycleWavesJson:string;
  cycleWaves:IWave[];
  mainWaves:IWave[];
  overlayWaves:IWave[];
  spotData:CurrentSpotData;
}


export class CurrentSpotData
{
    constructor(){}
    open:CloseSpot;
    currentValue:number;
    diffValue:number;
    diffPercent:number;

public get diffValueFormatted():string
{
  if(!this.diffValue)
  {
    return "";
  }
   return this.diffValue.toFixed(2);
}
  public get diffPercentFormatted(): string {
    if(!this.diffPercent)
    {
      return "";
    }
    return this.diffPercent.toFixed(2);
  }

}


export class CloseSpot
{
    datetime:Date
    value:number
}

export class ISendTradeData
{
  constructor(){};
  buySell:string;
  price:number;
  size:number;
  symbol:string;
  time:number;
  type:string;

}

export function getTradeTime(val:number):UTCTimestamp
{
  return val/1000 as UTCTimestamp
}

export interface IWave
{
  type:number;
  direction:number;
  data:ISendTradeData[]
}

export interface Config
{
  allWaves:IWave[];
  numberOfWaves:number;
  totalNumberOfWaves:number;
  pernamentLineWidth:number;
  pernamentLineHeight:number;
  intermediateLineHeight:number;
  smaDiff:number;

  name:string;
}

export enum AnnotationTypes
{
  PRICELINE="PRICELINE"
}
